import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import Candidates from 'components/candidates'
import Candidate from 'components/candidate'
import Question from 'components/question'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Route } from 'react-router-dom'
import config from 'config'
// import Tabletop from "tabletop";
import ScrollToTopOnMount from 'components/scrollToTop'

const ARTICLE_ID = '422977157907'

const QUESTIONS = [
  {
    label:
      "Le salaire de 250'000 francs des conseillers administratifs est-il adéquat?"
  },
  {
    label: 'Faut-il armer la police municipale?'
  },
  {
    label:
      "La mesure prioritaire pour combattre le réchauffement climatique à l'échelon communal?"
  },
  {
    label:
      'La subvention de 45 millions de francs octroyée au Grand Théâtre est-elle trop élevée?'
  },
  {
    label: 'S’il faut faire des économies, où couper en priorité?'
  },
  {
    label: 'Par quel moyen de transport vous rendez-vous au bureau le matin?'
  },
  {
    label: "Combien d'heures dormez-vous par nuit?"
  },
  {
    label:
      'En une phrase, pourquoi voter pour vous plutôt que pour un autre candidat?'
  }
]

export class AppComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      candidates: []
    }
  }

  componentDidMount() {
    // console.log(require('../../data.csv'))

    /* Tabletop.init({
      key: "1HqLyb-EOLTGLqNDDyMz8xGDg7gnMRHVe5bSG6WvBJkk",
      callback: googleData => {
        this.setState({
          candidates: googleData
        });
      },
      simpleSheet: true
    }); */

    this.setState({
      candidates: require('../../data.csv')
    })
  }

  render() {
    return (
      <div className='index'>
        <Masthead inverted articleId={ARTICLE_ID} />
        <ThemeSwitch />

        <div id='main-content'>
          <Route
            exact
            path='/'
            render={props => (
              <>
                <ScrollToTopOnMount {...props} />
                <Candidates
                  {...props}
                  candidates={this.state.candidates}
                  questions={QUESTIONS}
                />
              </>
            )}
          />

          <Route
            exact
            path={config.routes.candidates + ':candidateId'}
            render={props => (
              <>
                <Candidate
                  {...props}
                  candidates={this.state.candidates}
                  questions={QUESTIONS}
                />
              </>
            )}
          />

          <Route
            exact
            path={config.routes.candidates + ':candidateId/reponse/:answerId'}
            render={props => (
              <>
                <Candidate
                  {...props}
                  candidates={this.state.candidates}
                  questions={QUESTIONS}
                />
              </>
            )}
          />

          <Route
            exact
            path={config.routes.questions + ':questionId'}
            render={props => (
              <>
                <Question
                  {...props}
                  candidates={this.state.candidates}
                  questions={QUESTIONS}
                />
              </>
            )}
          />

          <Route
            exact
            path={config.routes.questions + ':questionId/candidat/:candidateId'}
            render={props => (
              <>
                <Question
                  {...props}
                  candidates={this.state.candidates}
                  questions={QUESTIONS}
                />
              </>
            )}
          />
        </div>

        {/* TODO Add your credits in this component */}
        <Footer
          mailTo='interactif@tamedia.ch'
          hidePortfolioTeaser
          locale='fr'
          articleId={ARTICLE_ID}
          credits={[
            ['Texte', 'Théo Allegrezza et Chloé Dethurens'],
            ['Vidéos', 'Georges Cabrera et Lorraine Fasler'],
            ['Conception', 'Mathieu Rudaz']
          ]}
        />
      </div>
    )
  }
}
